export interface TicketStatus {
  id: number
  name: Status
}

export type Status =
  | 'Closed'
  | 'Pending'
  | 'Assigned'
  | 'Pending Assignment'
  | 'New'
  | 'Pending Input'
  | 'Duplicate'
  | 'Rejected'

export enum TicketStatuses {
  CLOSED = 'Closed',
  PENDING = 'Pending',
  PENDING_ASSIGNMENT = 'Pending Assignment',
  NEW = 'New',
  PENDING_INPUT = 'Pending Input',
  DUPLICATE = 'Duplicate',
  REJECTED = 'Rejected',
}

export enum TicketStatusesIds {
  CLOSED = 4,
}
